import React from 'react'

import useDiscountToken from '../../hooks/useDiscountToken'
import useDiscountCode from '../../hooks/useDiscountCode'
import LinkButton from '../Link/LinkButton'
import useHandlebarsContext from '../../hooks/useHandlebarsContext'
import { insertHandlebarsTemplate } from '../../utils/insertHandlebarsTemplate'
import { FormattedSKU } from '../../hooks/useSKUs'
import { Button, ExternalLink } from '../../types/page'

interface Props {
  link: Button<ExternalLink>
  className?: string
  pageSKU?: Partial<FormattedSKU | undefined>
}

const PurchaseButton: React.FC<Props> = ({ link, className, pageSKU }) => {
  const handlebarsContext = useHandlebarsContext()
  const modifiedLink = {
    ...link,
    buttonText:
      insertHandlebarsTemplate(link.buttonText, handlebarsContext) ??
      link.buttonText,
    action: {
      ...link.action,
      url:
        insertHandlebarsTemplate(link.action.url, handlebarsContext, {
          noEscape: true,
        }) ?? link.action.url,
    },
  }
  if (pageSKU?.plan_code) {
    return (
      <PurchaseButtonWithProduct link={modifiedLink} className={className} />
    )
  }

  return (
    <PurchaseButtonWithoutProduct link={modifiedLink} className={className} />
  )
}

const PurchaseButtonWithProduct: React.FC<Props> = ({ link, className }) => (
  <LinkButton
    className={className}
    href={link.action.url}
    color={link.color === 'default' ? 'primary' : link.color}
    variant={link.variant}
    mixpanelTracking={link.mixpanelTracking}
  >
    {link.buttonText}
  </LinkButton>
)

const PurchaseButtonWithoutProduct: React.FC<Props> = ({ link, className }) => {
  const discountToken = useDiscountToken()
  const planCode = link.action.url.substring(
    link.action.url.lastIndexOf('/') + 1
  )
  const { isLoading, isError, data } = useDiscountCode(planCode, discountToken)

  if (!discountToken || isLoading || isError || !data) {
    return (
      <LinkButton
        className={className}
        href={link.action.url}
        color={link.color === 'default' ? 'primary' : link.color}
        variant={link.variant}
        mixpanelTracking={link.mixpanelTracking}
      >
        {link.buttonText}
      </LinkButton>
    )
  }

  if (!link.action.url.includes('?dt')) {
    link.action.url = link.action.url + '?dt=' + discountToken
  }
  return (
    <LinkButton
      className={className}
      href={link.action.url}
      color={link.color === 'default' ? 'primary' : link.color}
      variant={link.variant}
      mixpanelTracking={link.mixpanelTracking}
    >
      {link.buttonText}
    </LinkButton>
  )
}

export default PurchaseButton
